import type { MmscanNavItem } from '@mmscan/angular-ui/navigation';

/** A nav item with the permission it needs; `canAccess: false` hides it. */
export interface GatedNavItem extends Omit<MmscanNavItem, 'children'> {
  canAccess?: boolean;
  children?: readonly GatedNavItem[];
}

/**
 * Drops the items the user can't access, and groups left with no visible children, so the shell
 * never shows an empty menu.
 */
export function visibleNavItems(items: readonly GatedNavItem[]): MmscanNavItem[] {
  return items.flatMap(({ canAccess, children, ...item }) => {
    if (canAccess === false) return [];
    if (!children) return [item];
    const visible = visibleNavItems(children);
    return visible.length ? [{ ...item, children: visible }] : [];
  });
}
